import { Button, EmptyState, usePageTitle } from '@xinfer/ui';
import { Link, useLocation } from 'react-router-dom';

/**
 * A real 404, now that there are real addresses to get wrong.
 *
 * Before the router every unknown path rendered the Overview page, so a typo
 * in a shared link silently showed the wrong thing rather than saying so.
 */
export function NotFound() {
  usePageTitle('Not found');
  const location = useLocation();

  return (
    <EmptyState
      title="No such page"
      description={
        <>
          Nothing is served at <code className="font-mono">{location.pathname}</code>.
        </>
      }
      action={
        <Button asChild variant="outline">
          <Link to="/">Back to overview</Link>
        </Button>
      }
    />
  );
}
